"use client";
import LanguageSpecViewer from "@comps/LanguageSpecification";
import { useEffect, useState } from "react";


export default function Debugatron3000() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false)
  }, [])


  if (!loading) return <LanguageSpecViewer />;
}
